import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState } from "react";
import tw from "tailwind-styled-components";
import STooltip from "../../Tooltip";
import { SButton, SDivider, SIcon } from "../../components";
import SBadge from "../../components/SBadge";
const Section = tw.div`
  p-3 !pb-0 pt-2
`;
export const CSSEditorSection = ({ title, titleComponent: TitleComponent, icon, helpText, children, beta, sectionClassName, startCollapsed = false, collapsable = true, accessory })=>{
    const [show, setShow] = useState(!startCollapsed);
    const header = TitleComponent ? /*#__PURE__*/ _jsx(TitleComponent, {}) : /*#__PURE__*/ _jsxs("div", {
        className: `grid grid-cols-2 items-center justify-between gap-3`,
        children: [
            /*#__PURE__*/ _jsxs("div", {
                onClick: ()=>{
                    if (collapsable && !show) {
                        setShow(!show);
                    }
                },
                className: `grid grid-cols-[auto,auto,auto] items-center justify-start gap-3 text-md ${collapsable && !show ? "cursor-pointer" : ""}`,
                children: [
                    typeof icon == "function" ? icon({}) : icon,
                    title,
                    beta && /*#__PURE__*/ _jsx(SBadge.Beta, {})
                ]
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: `flex flex-row items-center justify-end`,
                children: [
                    accessory,
                    collapsable && /*#__PURE__*/ _jsx(SButton, {
                        isMinimal: true,
                        className: "!m-0 h-[23px] !pl-3 !pr-0",
                        onClick: collapsable ? ()=>setShow(!show) : undefined,
                        children: /*#__PURE__*/ _jsx("span", {
                            className: `transform ${show ? "rotate-90" : "rotate-0"} text-white/40`,
                            children: /*#__PURE__*/ _jsx(SIcon, {
                                size: 10,
                                type: "chevron-right-light"
                            })
                        })
                    })
                ]
            })
        ]
    });
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: `py-4 px-4 ${show || !collapsable ? "!pb-2" : ""}`,
                children: /*#__PURE__*/ _jsx("div", {
                    children: helpText ? /*#__PURE__*/ _jsx(STooltip, {
                        content: helpText !== null && helpText !== void 0 ? helpText : "",
                        width: "240px",
                        placement: "top-start",
                        children: header
                    }) : header
                })
            }),
            (show || !collapsable) && /*#__PURE__*/ _jsxs("div", {
                className: `p-3 pl-2 !pb-0 pt-2 ${sectionClassName}`,
                children: [
                    children,
                    /*#__PURE__*/ _jsx("div", {
                        className: "my-3"
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(SDivider, {})
        ]
    });
};
